import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
// react-bootstarp
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
// custom compo
import Layout from '../components/common/layout';
import CourseCardWrapper from '../components/courseCardWrapper';
import CategoryAccordionMenus from '../components/categoryAccordionMenus';

const AccordionWrapper = styled(Accordion)`
  margin-bottom: 2rem;
  
  > .accordion-item {
    & > .accordion-header {
      & > .accordion-button {
        box-shadow: none;
        background-color: #f9c7ab17;
        border-color: #dadada;
        color: #000;

        &:focus {
          box-shadow: none;
        }

        &:not(.collapsed)::after {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ff7e33bd'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
        }
      }
    }

    & > .accordion-collapse > .accordion-body {
    padding: 0;
  }
  }


  .accordion {
    .accordion-item {
      .accordion-button {
        border-radius: 0;
        &.collapsed {
          border-radius: 0;
        }
      }
      .accordion-collapse {
        border-radius: 0;
      }
    }
  }
`;

export default function CategoryTemplate({
  pageContext: { largeCategory, mediumCategory },
}) {
  return (
    <>
      <Layout>
        <Helmet htmlAttributes={{ lang: 'ko' }}>
          <title>{largeCategory}</title>
          <meta name="description" content="" />
        </Helmet>

        <section className="py-5">
          <Container>
            <Row>
              <Col xs className="d-lg-none">
                <AccordionWrapper>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>카테고리</Accordion.Header>
                    <Accordion.Body>
                      <CategoryAccordionMenus activeKey={largeCategory} currMidCate={mediumCategory} />
                    </Accordion.Body>
                  </Accordion.Item>
                </AccordionWrapper>
              </Col>

              <Col md={0} lg={3} xl={2} className="d-none d-lg-block">
                <CategoryAccordionMenus activeKey={largeCategory} currMidCate={mediumCategory} />
              </Col>

              <Col md={12} lg={9} xl={10}>
                {mediumCategory ? (
                  <CourseCardWrapper
                    cateName={largeCategory}
                    midCateName={mediumCategory}
                  />
                ) : (
                  <CourseCardWrapper cateName={largeCategory} />
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </Layout>
    </>
  );
}
